import { render } from "./EstimationsPage.vue?vue&type=template&id=1acbc7e7"
import script from "./EstimationsPage.vue?vue&type=script&lang=js"
export * from "./EstimationsPage.vue?vue&type=script&lang=js"

import "./EstimationsPage.vue?vue&type=style&index=0&id=1acbc7e7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__